export const SECONDARY_NAV = [
  { label: "New Arrivals", path: "/new-arrivals" },
  { label: "Bestsellers!", path: "/bestsellers" },
  { label: "Shop New Design", path: "/shop" },
  { label: "Collections", path: "/collections" },
  { label: "Exclusive Sale", path: "/sale" },
  { label: "Boutiques", path: "/boutiques" },
  { label: "Spotted", path: "/spotted" },
  { label: "Gift Card", path: "/gift-card" },
  { label: "About Us", path: "/about" }
];
